<!-- Modal Header -->
<div class="modal-header entity-edit-header">
  <h3 class="modal-title"><strong>{{ modalTitle }}</strong></h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<!-- Modal Body -->
<form class="entity-edit-form" [hidden]="minimise" novalidate>
  <div class="modal-body">
    @if (showEntityLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    @if (!showEntityLoader) {
<div>
      <table class="subTable custom-table">
        <tr>
          <th>LEID</th>
          <th>LE NAME</th>
          <th>EIN</th>
          <th colspan="3">ADDRESS</th>
          <th>LE TYPE</th>
          <th>HO LEID</th>
          <th>HO TAX CODE</th>
          <th>HO REPORTING PERIOD</th>
          <th>STATE DOMICILE</th>
          <th>BUSINESS</th>
          <th class="actions-col">
            <i class="fa fa-plus-circle color-green" (click)="addRows()" title="Add row"></i>
          </th>
        </tr>
        @for (entity of external_entity_list; track $index; let i = $index) {
<tr>
          <td>
            <input type="text"
                   maxlength="18"
                   [(ngModel)]="entity.leid"
                   [ngModelOptions]="{standalone: true}"
                   class="form-control input-sm subtableRowHeight"
                   (input)="sanitizeLeid(entity)">
          </td>
          <td>
            <input type="text"
                   [(ngModel)]="entity.le_name"
                   [ngModelOptions]="{standalone: true}"
                   class="form-control input-sm subtableRowHeight">
          </td>
          <td>
            <input type="text"
                   maxlength="10"
                   [(ngModel)]="entity.ein"
                   [ngModelOptions]="{standalone: true}"
                   class="form-control input-sm subtableRowHeight">
          </td>
          <td colspan="3">
            <input type="text"
                   [(ngModel)]="entity.address_line1"
                   [ngModelOptions]="{standalone: true}"
                   class="form-control input-sm"
                   placeholder="Address Line 1">
            <input type="text"
                   [(ngModel)]="entity.address_line2"
                   [ngModelOptions]="{standalone: true}"
                   class="form-control input-sm"
                   placeholder="Address Line 2">
            <div class="address-container">
              <div class="address-field">
                <input type="text"
                       [(ngModel)]="entity.address_city"
                       [ngModelOptions]="{standalone: true}"
                       class="form-control input-sm no-border"
                       placeholder="City">
              </div>
              <div class="address-field">
                <select class="form-control input-sm"
                        [(ngModel)]="entity.address_state"
                        [ngModelOptions]="{standalone: true}">
                  <option value="">Select State</option>
                  @for (state of allUSStates; track $index) {
<option [value]="state.STATE_CODE">
                    {{ state.STATE_DESC }}
                  </option>
}
                </select>
              </div>
              <div class="address-field">
                <input type="text"
                       [(ngModel)]="entity.address_zip"
                       [ngModelOptions]="{standalone: true}"
                       class="form-control input-sm no-border"
                       placeholder="Zip">
              </div>
            </div>
          </td>
          <td>
            <select class="form-control input-sm subtableRowHeight"
                    [(ngModel)]="entity.le_type"
                    [ngModelOptions]="{standalone: true}">
              <option value="" disabled>Select</option>
              @for (option of leType; track $index) {
<option [value]="option.name">{{ option.name }}</option>
}
            </select>
          </td>
          <td>
            <select class="form-control input-sm subtableRowHeight"
                    [(ngModel)]="entity.ho_leid"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onLeidChange($event, entity)"
                    (click)="entitySelection(entity.occurance)">
              <option [ngValue]="null">Select HO LEID</option>
              @for (item of leidList; track $index) {
<option [ngValue]="item">{{ item.label }}</option>
}
            </select>
          </td>
          <td>
            <select class="form-control input-sm subtableRowHeight"
                    [(ngModel)]="entity.ho_cdr_no"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onCdrChange($event, entity)"
                    (click)="entitySelection(entity.occurance)"
                    [disabled]="!entity.cdr_list || entity.cdr_list.length === 0">
              <option [ngValue]="null">Select HO Tax Code</option>
              @for (item of entity.cdr_list; track $index) {
<option [ngValue]="item">{{ item.label }}</option>
}
            </select>
          </td>
          <td>
            <select class="form-control input-sm subtableRowHeight"
                    [(ngModel)]="entity.ho_reporting_period"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!entity.reporting_period_list || entity.reporting_period_list.length === 0">
              <option [ngValue]="null">Select Reporting Period</option>
              @for (item of entity.reporting_period_list; track $index) {
<option [ngValue]="item">{{ item.label }}</option>
}
            </select>
          </td>
          <td>
            <input type="text"
                   [(ngModel)]="entity.state_domicile"
                   [ngModelOptions]="{standalone: true}"
                   class="form-control input-sm subtableRowHeight">
          </td>
          <td>
            @if (entity.is_me_visible) {
<select
                    class="form-control input-sm subtableRowHeight"
                    [(ngModel)]="entity.me_key"
                    [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">Select Business</option>
              @for (item of meList; track $index) {
<option [ngValue]="item">{{ item.label }}</option>
}
            </select>
}
            @if (!entity.is_me_visible) {
<input
                   type="text"
                   class="form-control input-sm subtableRowHeight"
                   placeholder="Select ME"
                   disabled>
}
          </td>
          <td class="row-actions">
            @if (entity.le_key === 'NEW') {
<i class="fa fa-minus-circle color-red"
              
               (click)="removeRow(i)"
               title="Remove row"></i>
}
          </td>
        </tr>
}
      </table>
    </div>
}
  </div>
</form>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm"
          type="button"
          [disabled]="isSaveClicked || (isCreateMode && external_entity_list.length === 0)"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save and Proceed
  </button>
  <button class="btn btn-default btn-sm" type="button" (click)="reset()">Reset</button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
